import { render, staticRenderFns } from "./MovieDetailPage.vue?vue&type=template&id=917b0b5e&scoped=true&"
import script from "./MovieDetailPage.vue?vue&type=script&lang=js&"
export * from "./MovieDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./MovieDetailPage.vue?vue&type=style&index=0&id=917b0b5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917b0b5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VChip,VIcon,VSwitch,VTextarea})
